/* Big Bear Honey — Variant Featured Image updater
   The hero <div id="bbh-variant-hero"> is rendered server-side by Liquid.
   This script updates its <img> src whenever the user picks a different variant.
   Cooktech only re-renders inside xo-gallery; the hero div persists. */
(function () {
  'use strict';

  var heroImg = document.getElementById('bbh-variant-hero') &&
                document.getElementById('bbh-variant-hero').querySelector('img');
  if (!heroImg) return;

  var handle = window.location.pathname.split('/products/')[1];
  if (!handle) return;
  handle = handle.split(/[?#]/)[0];

  var variantImageMap = {};

  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      product.variants.forEach(function (v) {
        if (v.featured_image) variantImageMap[v.id] = v.featured_image.src;
      });

      // Listen for variant radio changes
      document.addEventListener('change', function (e) {
        if (!e.target || e.target.type !== 'radio') return;
        setTimeout(function () {
          var idInput = document.querySelector('form [name="id"]');
          if (!idInput) return;
          var src = variantImageMap[parseInt(idInput.value, 10)];
          if (!src) return;
          var img = document.querySelector('#bbh-variant-hero img');
          if (!img) return;
          img.style.opacity = '0.3';
          var tmp = new window.Image();
          tmp.onload = function () { img.src = src; img.style.opacity = '1'; };
          tmp.src = src;
        }, 80);
      });
    });
})();
